module.exports = __webpack_public_path__ + "static/media/IMG_4292.0335c4ba.PNG";